(function () {
  // --- NOVO (mínimo): barra de progresso custom abaixo do vídeo, sem mexer no player ---
  function formatTime(sec) {
    if (!isFinite(sec)) return '0:00';
    sec = Math.max(0, Math.floor(sec));
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return `${m}:${String(s).padStart(2, '0')}`;
  }

  function ensureProgressUI(video) {
    if (!video || video.dataset.progressUi === '1') return;
    video.dataset.progressUi = '1';

    // CSS 1x (só para a barra)
    if (!document.getElementById('custom-video-progress-css')) {
      const style = document.createElement('style');
      style.id = 'custom-video-progress-css';
      style.textContent = `
        .custom-video-ui{ margin-top:10px; user-select:none; }
        .custom-video-progress{
          position:relative; height:8px; border-radius:999px;
          background: rgba(0,0,0,.18); cursor:pointer;
        }
        .custom-video-progress__fill{
          position:absolute; left:0; top:0; bottom:0; width:0%;
          border-radius:999px; background: rgba(0,0,0,.75);
        }
        .custom-video-progress__knob{
          position:absolute; top:50%; left:0%;
          width:14px; height:14px; border-radius:999px;
          transform: translate(-50%,-50%);
          background:#000; box-shadow:0 0 0 3px rgba(255,255,255,.9);
          pointer-events:none;
        }
        .custom-video-time{
          margin-top:6px; font-size:12px; opacity:.75;
          display:flex; justify-content:flex-end; gap:2px;
        }
      `;
      document.head.appendChild(style);
    }

    // Cria UI e coloca EMBAIXO do vídeo (sem mover o vídeo / sem alterar o player)
    const ui = document.createElement('div');
    ui.className = 'custom-video-ui';
    ui.innerHTML = `
      <div class="custom-video-progress" role="slider" aria-label="Video progress">
        <div class="custom-video-progress__fill"></div>
        <div class="custom-video-progress__knob"></div>
      </div>
      <div class="custom-video-time">
        <span class="custom-video-time__cur">0:00</span>
        <span class="custom-video-time__sep"> / </span>
        <span class="custom-video-time__dur">0:00</span>
      </div>
    `;
    video.insertAdjacentElement('afterend', ui);

    const progress = ui.querySelector('.custom-video-progress');
    const fill = ui.querySelector('.custom-video-progress__fill');
    const knob = ui.querySelector('.custom-video-progress__knob');
    const curEl = ui.querySelector('.custom-video-time__cur');
    const durEl = ui.querySelector('.custom-video-time__dur');

    function render() {
      const dur = video.duration || 0;
      const cur = video.currentTime || 0;
      const pct = dur ? (cur / dur) * 100 : 0;
      fill.style.width = `${pct}%`;
      knob.style.left = `${pct}%`;
      curEl.textContent = formatTime(cur);
      durEl.textContent = formatTime(dur);
    }

    video.addEventListener('loadedmetadata', render);
    video.addEventListener('durationchange', render);
    video.addEventListener('timeupdate', render);

    // Click-to-seek (não interfere no play/pause do player)
    function seekByX(clientX) {
      const rect = progress.getBoundingClientRect();
      const x = Math.min(Math.max(clientX - rect.left, 0), rect.width);
      const pct = rect.width ? x / rect.width : 0;
      const dur = video.duration || 0;
      if (dur) video.currentTime = pct * dur;
    }

    let dragging = false;
    progress.addEventListener('click', (e) => seekByX(e.clientX));
    progress.addEventListener('mousedown', (e) => {
      dragging = true;
      seekByX(e.clientX);
    });
    window.addEventListener('mousemove', (e) => {
      if (!dragging) return;
      seekByX(e.clientX);
    });
    window.addEventListener('mouseup', () => (dragging = false));

    progress.addEventListener('touchstart', (e) => {
      dragging = true;
      seekByX(e.touches[0].clientX);
    }, { passive: true });
    progress.addEventListener('touchmove', (e) => {
      if (!dragging) return;
      seekByX(e.touches[0].clientX);
    }, { passive: true });
    progress.addEventListener('touchend', () => (dragging = false));

    render();
  }

  function unmuteVideoInside(container) {
    if (!container) return;

    // tenta achar o vídeo no DOM normal
    let video = container.querySelector('video');

    // se estiver em shadow DOM, tenta achar lá também
    if (!video) {
      const dm = container.closest('deferred-media') || container.querySelector('deferred-media');
      if (dm && dm.shadowRoot) {
        video = dm.shadowRoot.querySelector('video');
      }
    }

    if (!video) return;

    // remove mute forçado pelo tema
    video.muted = false;
    video.removeAttribute('muted');

    // garante volume
    if (video.volume === 0) video.volume = 1;

    // --- NOVO (mínimo): adiciona barra de progresso ---
    ensureProgressUI(video);
  }

  function handlePlayClick(e) {
    const btn = e.target.closest('.deferred-media__poster-button');
    if (!btn) return;

    const media = btn.closest('.product-media') || btn.closest('deferred-media') || btn.parentElement;

    // o tema injeta o <video> DEPOIS do clique, então tentamos algumas vezes bem rápido
    let tries = 0;
    const timer = setInterval(() => {
      tries++;
      unmuteVideoInside(media);

      // se já conseguiu achar o vídeo, para
      const hasVideo =
        (media && media.querySelector && media.querySelector('video')) ||
        (media && media.closest && media.closest('deferred-media') && media.closest('deferred-media').shadowRoot && media.closest('deferred-media').shadowRoot.querySelector('video'));

      if (hasVideo || tries >= 20) clearInterval(timer);
    }, 50);
  }

  // Captura o clique no play do poster do deferred-media
  document.addEventListener('click', handlePlayClick, true);

  // Fallback: se o vídeo começar a tocar e ainda estiver mudo, desmuta no evento "play"
  document.addEventListener('play', function (e) {
    const v = e.target;
    if (v && v.tagName === 'VIDEO') {
      v.muted = false;
      v.removeAttribute('muted');
      if (v.volume === 0) v.volume = 1;

      // --- NOVO (mínimo): adiciona barra de progresso ---
      ensureProgressUI(v);
    }
  }, true);
})();